<template>
  <a-card class="m-card-lottie">
    <m-anim
      :options="notfound"
      class="anim"
      :height="isMobile ? 200 : 500"
      :width="isMobile ? 200 : 500"
    ></m-anim>
    <h1 class="m-remove">404 AREA!</h1>
    <h3 class="margin-bottom">Sepertinya kamu sedang tersesat, kembalilah ke jalan yang benar 😜</h3>
    <a-button type="primary" block>
      <router-link :to="{path: '/'}">
        <a-icon type="rollback" />&nbsp; Jalan Kebenaran
      </router-link>
    </a-button>
  </a-card>
</template>

<script>
import lottie from "vue-lottie";
import notfound from "@/assets/anim/404.json";
export default {
  name: "E404",
  components: { "m-anim": lottie },
  data() {
    return {
      notfound: { animationData: notfound, loop: true }
    };
  },
  computed: {},
  beforeRouteEnter(to, from, next) {
    next();
  }
};
</script>

<style>
</style>